export default function TemplateLoader(templateElement, data) {
	const template = templateElement;
	let dataArray = data;

	if (!template) {
		console.error('TemplateLoader did not receive a valid template element');
		return false;
	}

	if (typeof data !== 'object') {
		if (typeof data === 'undefined') {
			console.warn('TemplateLoader: Data parameter is undefined. This will not populate template with anything');
			return false;
		}
		console.error('TemplateLoader: Data parameter is not an object or array');
		return false;
	}

	let templateHtml = template.innerHTML.trim();

	// If data is not an array, create an array of objects
	if (!Array.isArray(data)) {
		dataArray = [];
		dataArray.push(data);
	}

	templateHtml = dataArray.map((dataObj) => {
		let templateWithData = templateHtml;

		Object.keys(dataObj).forEach((key) => {
			templateWithData = templateWithData.replace(new RegExp('{' + key + '}', 'g'), dataObj[key]);
		});

		return templateWithData;
	});

	const htmlString = templateHtml.join('');
	const htmlFragment = document.createRange().createContextualFragment(htmlString);

	return { htmlFragment, htmlString };
}
